export default __webpack_public_path__ + "static/media/logo-emotiony.dd1259e8.svg";